document.addEventListener("DOMContentLoaded", function() {
    function initializeShowMoreButton() {
        const swatchContainers = document.querySelectorAll(".globo-product-groups-collection .gsw-list-product-groups"); // Container for all product groups
        const limit = 4; // Number of swatches to display initially

        swatchContainers.forEach(container => {
            const swatches = container.querySelectorAll(".gsw-prg-item"); // Individual swatch items

            if (swatches.length > limit) {
                // Hide all swatches beyond the first 4
                for (let i = limit; i < swatches.length; i++) {
                    swatches[i].style.display = "none";
                }

                // Get the main product link from the first swatch
                const mainProductLink = swatches[0].querySelector("a").getAttribute("href");

                // Create and style the "Show More" button to match swatch style
                const showMoreButton = document.createElement("button");
                showMoreButton.textContent = "Show More";
                showMoreButton.className = "show-more-button";
                
                // Style the button to match the swatch size and positioning
                showMoreButton.style.display = "inline-block";
                showMoreButton.style.width = "auto";
                showMoreButton.style.height = "40px"; // Match this to your swatch height
                showMoreButton.style.padding = "0 10px";
                showMoreButton.style.backgroundColor = "#007bff"; // Optional: Set to match swatch style
                showMoreButton.style.color = "#fff";
                showMoreButton.style.border = "none";
                showMoreButton.style.cursor = "pointer";
                showMoreButton.style.borderRadius = "5px"; // Optional: Round like the swatches
                showMoreButton.style.fontSize = "14px"; // Adjust to match swatch text size

                // Position the button immediately after the last visible swatch
                swatches[limit - 1].insertAdjacentElement("afterend", showMoreButton);

                // Add click event to redirect to the main product page
                showMoreButton.addEventListener("click", () => {
                    window.location.href = mainProductLink;
                });
            }
        });
    }

    // Use setTimeout to ensure GLO app has loaded before running
    function waitForSwatches() {
        if (document.querySelectorAll(".globo-product-groups-collection .gsw-list-product-groups .gsw-prg-item").length > 0) {
            initializeShowMoreButton();
        } else {
            setTimeout(waitForSwatches, 500); // Retry every 500ms until elements are loaded
        }
    }

    waitForSwatches();
});

document.addEventListener("DOMContentLoaded", function() {
    // Function to check if the current page is in the "Luxury Zone" collection
    function checkLuxuryZonePage() {
        if (window.location.pathname.includes("/collections/luxury-zone")) {
            // Get the current full URL (including page query) to use as a unique key
            const currentPage = window.location.href;

            // Check if this page has already been refreshed in this session
            if (sessionStorage.getItem("luxuryZoneLastPage") !== currentPage) {
                // Set a timeout to refresh the page after 1 second
                setTimeout(function() {
                    window.location.reload();
                    // Mark this page as refreshed in session storage
                    sessionStorage.setItem("luxuryZoneLastPage", currentPage);
                }, 1000); // 1-second delay
            }
        } else {
            // Clear the session storage flag when leaving the "Luxury Zone" collection
            sessionStorage.removeItem("luxuryZoneLastPage");
        }
    }

    // Run the check function every second to handle each page load or pagination change
    setInterval(checkLuxuryZonePage, 1000); // Adjust timing as needed
});


